/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Notes_Add_TitleInputs */



/**
* | output |
* | --- |
* | "Add Notes" |
*
* @param {Event_Notes_Add_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_notes_add_title = /** @type {((inputs?: Event_Notes_Add_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Notes_Add_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter des notes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Notizen hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi note")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить примечания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar notas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加备注")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メモを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नोट्स जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar notas")
	return /** @type {LocalizedString} */ ("Add Notes")
});